// src/components/Header.js
import React, { useState, useEffect, useRef } from "react";
import user from "../assets/user.jpg";
import { Link, useNavigate } from 'react-router-dom';
import { logout } from "../utils/api";
import Logofull from "../assets/FullLogo.png";
import { useDispatch, useSelector } from "react-redux";
import { AxiosError } from "./sessionexpiry";

const Header = ({ isSidebarCollapsed, toggleSidebar, isMobile }) => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileDropdownRef = useRef(null);

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  const loginScreen = useSelector((state) => state.login?.loginScreen || []);
  const profilePic = loginScreen.length > 0 ? loginScreen[1].profile_pic : "";
  const business_name = loginScreen.length > 0 ? loginScreen[1].business_name : "";
  const email = loginScreen.length > 0 ? loginScreen[1].email : "";
  

  const toggleNotificationDropdown = (e) => {
    e.preventDefault();
    setIsNotificationOpen(!isNotificationOpen);
    setIsProfileOpen(false);
  };

  const toggleProfileDropdown = (e) => {
    e.preventDefault();
    setIsProfileOpen(!isProfileOpen);
    setIsNotificationOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest("#notificationBtn") && !event.target.closest("#notificationDropdown")) {
        setIsNotificationOpen(false);
      }

      if (profileDropdownRef.current && 
          !profileDropdownRef.current.contains(event.target) && 
          !event.target.closest("a[onClick]")) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      AxiosError(navigate, error);
      console.error("Logout error:", error.message);
    }
  };

  return (
    <div className="bg-[#F4F5FA] sidebar-open">
      <header
        className={`flex justify-between items-center bg-white p-4 shadow-sm transition-all duration-300 ${
          isSidebarCollapsed && !isMobile ? "lg:ml-20" : 
          !isSidebarCollapsed && !isMobile ? "ml-[270px]" : 
          "ml-0"
        }`}
      >
        {/* Search Bar - hidden on mobile */}
        <div className={`${isMobile ? 'hidden' : ''} lg:flex relative items-center ml-4`}>
          <input
            type="search"
            placeholder="Search"
            className="w-96 border rounded-full px-4 py-2 pl-10 pr-4"
          />
          <span className="material-symbols-outlined absolute left-2 text-gray-500">
            search
          </span>
        </div>

        {/* Mobile header section */}
        <div className="lg:hidden w-full relative flex items-center gap-1 md:gap-3">
          <button 
            className="md:h-12 h-full bg-blue-900 rounded"
            onClick={toggleSidebar}
            aria-label="Toggle menu"
            aria-expanded={!isSidebarCollapsed}
          >
            <span className="p-2 material-symbols-rounded text-white">
              {isSidebarCollapsed ? "menu" : "close"}
            </span>
          </button>
          <div className="h-10 md:h-12">
            <img className="h-full" src={Logofull} alt="Company Logo" />
          </div>
        </div>

        {/* Notification and Profile Section */}
        <div className="flex items-center gap-3">
          {/* Notification Dropdown */}
          {/* <div className="relative z-40">
            <button
              id="notificationBtn"
              className="hover:text-dark-900 relative flex h-11 w-11 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
              onClick={toggleNotificationDropdown}
              aria-expanded={isNotificationOpen}
            >
              <span
                id="notificationDot"
                className={`absolute right-0 top-0.5 z-1 h-2 w-2 rounded-full bg-orange-400 ${
                  isNotificationOpen ? "hidden" : "block"
                }`}
              >
                <span className="absolute -z-1 inline-flex h-full w-full animate-ping rounded-full bg-orange-400 opacity-75"></span>
              </span>
              <span className="material-symbols-outlined">notifications</span>
            </button>
            <div
              id="notificationDropdown"
              className={`absolute mt-[17px] h-[300px] w-[300px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg sm:w-[361px] right-0 ${
                isNotificationOpen ? "block" : "hidden"
              }`}
            >
              <div className="mb-3 flex items-center justify-between border-b border-gray-100 pb-3">
                <h5 className="text-lg font-semibold text-gray-800">
                  Notification
                </h5>
                <button
                  id="closeDropdown"
                  className="text-gray-500"
                  onClick={() => setIsNotificationOpen(false)}
                >
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>

              <ul className="custom-scrollbar flex h-auto max-h-[150px] flex-col overflow-y-auto text-xs">
                <li>
                  <a
                    className="flex gap-3 rounded-lg border-b border-gray-100 p-3 px-4.5 py-3 hover:bg-gray-100"
                    href="#"
                  >
                    <span className="relative z-1 block h-11 w-11 rounded-full">
                      <img src={`https://merchant-image.jantapays.com/images${profilePic.startsWith("/") ? profilePic : profilePic}`} alt="User" className="overflow-hidden rounded-full h-11 w-11" />
                      <span className="absolute bottom-0 right-0 z-10 h-2.5 w-full max-w-2.5 rounded-full border-[1.5px] border-white bg-green-500"></span>
                    </span>
                    <span className="block">
                      <span className="mb-1.5 block text-sm text-gray-500">
                        <span className="font-medium text-gray-800">
                          Terry Franci
                        </span> requests permission to change{" "}
                        <span className="font-medium text-gray-800">
                          Project - Nganter App
                        </span>
                      </span>
                      <span className="flex items-center gap-2 text-sm text-gray-500">
                        <span>Project</span>
                        <span className="h-1 w-1 rounded-full bg-gray-400"></span>
                        <span>5 min ago</span>
                      </span>
                    </span>
                  </a>
                </li>
              </ul>

              <a
                href="#"
                className="mt-3 flex justify-center rounded-lg border border-gray-300 bg-white p-3 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800"
              >
                View All Notifications
              </a>
            </div>
          </div> */}

          {/* Profile Dropdown */}
          <div className="relative z-40" ref={profileDropdownRef}>
            <a
              className="flex items-center gap-1 text-gray-700"
              href="#"
              onClick={toggleProfileDropdown}
              aria-expanded={isProfileOpen}
            >
              <span className="h-11 w-11 overflow-hidden rounded-full object-cover">
                <img className="h-11 w-11 object-cover" src={`https://merchant-image.jantapays.com/images${profilePic.startsWith("/") ? profilePic :  profilePic}`} alt="User" />
              </span>
              <span className="mr-1 block text-sm hidden md:block">{business_name}</span>
              <div className="hidden md:block">
                <span className="material-symbols-outlined">keyboard_arrow_down</span>
              </div>
            </a>

            {/* Profile Dropdown Menu */}
            <div
              id="dropdownMenu"
              className={`absolute right-0 mt-[17px] w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg ${
                isProfileOpen ? "block" : "hidden"
              }`}
            >
              <div>
                <span className="text-xm text-gray-700">
                {business_name}
                </span>
                <span className="mt-0.5 block text-xs text-gray-500">
                  {email}
                </span>
              </div>

              <ul className="flex flex-col gap-1 border-b border-gray-200 pb-3 pt-4">
                <li>
                  <Link
                    to="/Profile"
                    className="group flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
                  >
                    <span className="material-symbols-outlined">account_circle</span>
                    My Profile
                  </Link>
                </li>
              </ul>

              <a
                onClick={handleLogout}
                // className="group mt-3 flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 cursor-pointer"
                className="flex items-center p-2 rounded-xl text-gray-800 hover:bg-red-600 hover:text-white hover:shadow-md active:bg-red-600 active:text-white transition duration-200 ease-in-out mt-1 cursor-pointer"
              >
                <span className="material-symbols-outlined">logout</span>
                {/* <span className="iconify text-lg mr-3 hover:text-white active:text-white"></span> */}
                Logout
              </a>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;